import { render, staticRenderFns } from "./detailDialog.vue?vue&type=template&id=b5b32356&scoped=true"
import script from "./detailDialog.vue?vue&type=script&lang=js"
export * from "./detailDialog.vue?vue&type=script&lang=js"
import style0 from "./detailDialog.vue?vue&type=style&index=0&id=b5b32356&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b32356",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5b32356')) {
      api.createRecord('b5b32356', component.options)
    } else {
      api.reload('b5b32356', component.options)
    }
    module.hot.accept("./detailDialog.vue?vue&type=template&id=b5b32356&scoped=true", function () {
      api.rerender('b5b32356', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pluginManage/components/detailDialog.vue"
export default component.exports